"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ThemeProvider = exports.default = void 0;
var styles_1 = require("@mui/material/styles");
var palette_1 = require("./palette");
var components_1 = require("./components");
var typography_1 = require("./typography");
var colors_1 = require("./colors");
require("./assets/fonts/fonts.css");
var ThemeProvider_1 = __importDefault(require("./ThemeProvider"));
exports.ThemeProvider = ThemeProvider_1.default;
var themeName = 'WOM';
var theme = (0, styles_1.createTheme)({
  colors: colors_1.colors,
  themeName: themeName,
  palette: palette_1.palette,
  components: components_1.components,
  typography: typography_1.typography,
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 768,
      lg: 1200,
      xl: 1536
    }
  }
});
exports.default = theme;